import { render, staticRenderFns } from "./editConfig.vue?vue&type=template&id=19b7d32e&scoped=true&"
import script from "./editConfig.vue?vue&type=script&lang=js&"
export * from "./editConfig.vue?vue&type=script&lang=js&"
import style0 from "./editConfig.vue?vue&type=style&index=0&id=19b7d32e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b7d32e",
  null
  
)

export default component.exports